import FourZeroFour from './FourZeroFour';

export default FourZeroFour;